"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notice = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const desktop_1 = require("@alfalab/core-components/toast/desktop");
const typography_1 = require("@alfalab/core-components/typography");
const Notice = ({ onClose, open, text }) => {
    const [toastContainerRef, setToastContainerRef] = (0, react_1.useState)(null);
    const getPortalContainer = (0, react_1.useCallback)(() => toastContainerRef, [toastContainerRef]);
    const getToastContainerRef = (0, react_1.useCallback)((node) => {
        if (node !== null) {
            setToastContainerRef(node);
        }
    }, []);
    return ((0, jsx_runtime_1.jsx)("div", { ref: getToastContainerRef, children: (0, jsx_runtime_1.jsx)(desktop_1.ToastDesktop, { anchorElement: toastContainerRef, getPortalContainer: getPortalContainer, open: open, position: 'top', block: true, onClose: onClose, useAnchorWidth: true, role: 'alert', children: (0, jsx_runtime_1.jsx)(typography_1.Typography.Text, { view: 'primary-medium', children: text }) }) }));
};
exports.Notice = Notice;
